import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import axios from '../../../axios-url';
import {Dialog} from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import {TabView, TabPanel} from 'primereact/tabview';
import {ProgressSpinner} from 'primereact/progressspinner';
import {Calendar} from 'primereact/calendar';
import Assigning from './Assigning';
import { DROPDOWN_CONFIG, DATATABLE_CONFIG, APPROVAL_PATH_SUBMENU_ID} from '../../../shared/Config';
import { RELATIONAL_OPERATORS, DECRYPT, HASACCESS } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
class ApprovalPath extends Component {
    state = {

        selectedData : [],
        approvalPathData : [],
        loading : false,
        display : false,
        
     
        
        ddlModuleData : null,
        ddlProcessData : null,
        ddlFieldData : null,
        ddlEmployeeData : null,
        approvalType : null,
        stage : null,
        sequence : null,
        stages :  [
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
            { label: '4', value: 4 },
            { label: '5', value: 5 },
            { label: '6', value: 6 },
            { label: '7', value: 7 },
            { label: '8', value: 8 },
            { label: '9', value: 9 },
            { label: '10', value: 10 },      
            { label: '11', value: 11 },
            { label: '12', value: 12 },
            { label: '13', value: 13 },
            { label: '14', value: 14 },
            { label: '15', value: 15 },
            { label: '16', value: 16 },
            { label: '17', value: 17 },
            { label: '18', value: 18 },
            { label: '19', value: 19 },
            { label: '20', value: 20 }        
        ],
        gridData : [],
        esGridData : [],
        esStage : null,
        esLevel : null,
        esHour : null,
        esTo : null,
        esSubHour : null,
        esDays : null,
        approvalPathId : null,
        Id:null,
        type : 'Add',

        addedApprovalType : [],
        addedStages : [],
        characterData : [],
        ApprovaltypeId : null,
        ApprovalpathstageId : null,
        Operator : null,
        FieldValue: '',
        FieldName : '',


        approvalPathName: '',
        moduleId: null,
        processId: null,
        ProcessType  : null,
        ProcessTypeShow : false,
        ProcessTypeLabel:'',
        rowData : null,
        rowDataIndex : null
    }


    deleteApprovalPath = () => {

        if(this.state.selectedData.length > 0){
            this.setState({loading : true});
    
            
            const updatedValue = this.state.selectedData.map( list => {
                return { DeleteID : list.approvalPathId};
            })
            
            axios.get('/master/api/deleteDynamicData?model=ApprovalPath&Id='+JSON.stringify(updatedValue))
            .then(response =>{
                if(response.status === 200){
                    this.growl.show({severity: 'success', summary: null, detail: 'Deleted Successfully.'});
                    this.getApprovalPath();
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })  
            this.setState({selectedData:[]})
        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select atleast one checkbox'});
        }


    }


    editItem = (rowData,type) => {
        let approvalPathId = rowData.approvalPathId;
        let moduleID = rowData.module;
        this.getFieldName(rowData.processId);
        this.setState({loading : true});
        axios.get('/master/api/GetApprovalPathMaster?id='+approvalPathId)
        .then(response =>{
            if(response.status === 200){

                let characteristicsMaster = [];
                let characteristicsData = [];
                if(response.data.characteristicsMaster && response.data.characteristicsMaster.length > 0){
                    characteristicsMaster = response.data.characteristicsMaster.filter(char => {
                        return char.approvalPathId === approvalPathId;
                    })
                }
                if(characteristicsMaster && characteristicsMaster.length > 0){
                    characteristicsData = characteristicsMaster.map(char => {
                        let fieldName = this.fieldName(char.filedName);
                        let approvalTypeName = this.approvalName(char.approvaltypeId);
                        return { CharId : char.char_Id, ApprovalPathId: approvalPathId, fieldName: char.filedName,fieldValue : char.fieldValue, operator: char.operator, stage : char.approvalpathstageId, approvalType: char.approvaltypeId, approvalTypeName: approvalTypeName,fieldNames: fieldName }
                    })
                }

                let escalationMaster = [];
                if(response.data.escalation && response.data.escalation.length > 0){                    
                    escalationMaster = response.data.escalation.map(es => {
                        return {Id : es.id, ApprovalPathId: approvalPathId, approvalPathStageId: es.approvalPathStageId, processId : es.approvalPathProcess, escalationLevel : es.escalationLevel, days :  es.days, hoursMinutes: es.hoursMinutes, escalationTo: es.escalationTo, totalMinutes: es.totalMinutes, escalationName: es.escalationName     }
                    })
                }
               
             
            

                let approvalPathDetail = [];
                let approvalPathData = [];
                if(response.data.approvalPathDetail && response.data.approvalPathDetail.length > 0){
                    approvalPathDetail = response.data.approvalPathDetail.filter(dt => {
                        return dt.approvalPathId === approvalPathId;
                    })
                }
                if(approvalPathDetail && approvalPathDetail.length > 0){
                    approvalPathData = approvalPathDetail.map(dt => {
                        let approvalTypeName = this.approvalName(dt.approvalTypeId);
                        return { Id:dt.id, ApprovalPathDetailId : dt.approvalPathDetailId, ApprovalPathId : dt.approvalPathId, sequence:dt.approvalPathSequence, stage : dt.approvalPathStageId, typeId: dt.approvalTypeId, type: approvalTypeName    }
                    })
                }


                
                this.getProcess(parseInt(moduleID));
                this.getLeaveType(rowData.processId);
                this.setState({display : true, type: type, approvalPathName:rowData.approvalPathName,moduleId:moduleID, approvalPathId:approvalPathId,Id:response.data.approvalPath.id,characterData : characteristicsData, esGridData: escalationMaster, gridData : approvalPathData });
                
             
                setTimeout(()=>{
                    this.setState({processId: rowData.processId});
                },2000)
                setTimeout(()=>{
                    this.setState({ProcessType: response.data.approvalPath.processType});
                },3000)
            }
            this.setState({loading : false});
        })
        .catch(err => {
            this.setState({loading : false});
        })    

       
    }

    

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button type="button" icon="pi pi-pencil" onClick={() => this.editItem(rowData,'Edit')}  className="p-button-info"></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Button type="button" icon="pi pi-eye" onClick={() => this.editItem(rowData,'View')}  className="p-button-secondary"></Button>
            }
          </div>;
    }


    componentDidMount(){
        localStorage.removeItem('GetTimeOff');
        this.getAccess = HASACCESS(APPROVAL_PATH_SUBMENU_ID);
        this.getApprovalPath();
        this.getModuleData();
        this.getEmployeeList();
        this.props.getMasterKeywordList('ApprovalType'); 
        this.props.getMasterCommonList('GetTimeOff')
        this.props.getMasterKeywordList('ExpenseType');//Get Service Dropdown list
    }


    getEmployeeList = () => {
        
        // const employeeStorageData = localStorage.getItem('employeeData');
        // if(!employeeStorageData){
            this.setState({loading : true});
            axios.get('/master/api/GetEmployee')
            .then(response =>{
                if(response.status === 200){
                 
                    let employeeData = [];
                    if(response.data && response.data.length > 0){
                        employeeData = response.data.map(list => {
                            return {label : list.employeeName, value : list.employeeId}
                        })
                    }
                    this.setState({ddlEmployeeData:employeeData});
                    //localStorage.setItem('employeeData',JSON.stringify(response.data));
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })    
        // }else{
        //     this.setState({ddlEmployeeData:JSON.parse(employeeStorageData)});
        // }
    }


    getApprovalPath = () => {
        //const approvalStorageData = localStorage.getItem('approvalPathData');
        //if(!approvalStorageData){
            this.setState({loading : true});
            axios.get('/master/api/GetApprovalPathMaster')
            .then(response =>{
                if(response.status === 200){
                    let data = []
                    if(response.data.approvalPathList!==undefined && response.data.approvalPathList.length > 0){
                        data = response.data.approvalPathList.map(val => {
                            return { "label": val.approvalPathName,"value":val.approvalPathId,...val }
                        })
                    }

                    this.setState({approvalPathData:data});
                    //localStorage.setItem('approvalPathData',JSON.stringify(data));
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })    
        // }else{
        //     this.setState({approvalPathData:JSON.parse(approvalStorageData)});
        // }
    }


    export = () => {
        this.dt.exportCSV();
    }

    clear = () => {
        this.setState({type:'Add',display:false,approvalPathName:'',moduleId:null,processId:null,employeeName:null,gridData:[],esGridData:[],characterData:[],addedStages:[],stage:null,sequence:null,esTo:null,esStage:null,esLevel:null,esDays:'',esHour:null,esSubHour:null, ProcessTypeShow : false, ProcessTypeLabel: '', ProcessType : null, Id : null})
      
    }


    updateDetail = (e) => {
        const { name, value} = e.target;

        this.setState({[name]:value})
        
        if(name === "moduleId") {       
            this.getProcess(value);
        } else if(name=== "esHour"){
            this.setState({esHour:value,esSubHour:value.getHours() + ":" +value.getMinutes()})
        } else if(name=== "processId"){
            this.getFieldName(value);
            this.getLeaveType(value);
        }

    }
    

    getLeaveType = (id) => {
        let companyDetails = localStorage.getItem('Company/GetCompany');
        let leaveProcess = 'b5585767-17f2-43d4-979b-efd170b4c3fa';
        let ExpenseClaimProcess = '03c893b0-d69c-488d-9bd3-fbc55845f68f'
        if(leaveProcess === id){
            this.setState({ProcessTypeShow:true, ProcessTypeLabel:'Select TimeOffType'});//ProcessTypeShow is to show or not show the dropdown after Process
        }else if(id === ExpenseClaimProcess) {
            this.setState({ProcessTypeShow:true, ProcessTypeLabel:'Select Expense Type'});
        }else{
            this.setState({ProcessTypeShow:false});//if you want to revert, remove this piece from if(leaveProcess === id) and uncomment the below
        }
    }

   
    getFieldName = (value) => {   
        this.setState({loading : true});
        axios.get('/master/api/GetFieldMasters?ProcessId='+value)
        .then(response =>{
            if(response.status === 200){
                let fieldData = [];
                if(response.data && response.data.length > 0){
                    fieldData = response.data.map(list => {
                        return { label : list.filedName, value : list.fieldId}
                    })
                }
                this.setState({ddlFieldData:fieldData});
            }
            this.setState({loading : false});
        })
        .catch(err => {
            this.setState({loading : false});
        })    
    }


    getProcess = (value) => {
            this.setState({loading : true});
            axios.get('/master/api/GetProcesses?Id='+value)
            .then(response =>{
                if(response.status === 200){
                    let processData = response.data.map( pro => {
                        return { label : pro.processDescription, value: pro.processId}
                    });
                    this.setState({ddlProcessData:processData});
                  
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })    
    }

    getModuleData = () => {       
        const moduleStorageData = localStorage.getItem('moduleData');
        if(!moduleStorageData){
        axios.get('/master/api/GetModuleMasters')
        .then(response =>{
            if(response.status === 200){

                let moduleData = response.data.map( mod => {
                    return { label : mod.moduleDescription, value: mod.moduleId}
                });

                this.setState({ddlModuleData:moduleData});         
                localStorage.setItem('moduleData',JSON.stringify(moduleData)); 
            } 
        })
        .catch(err => {
           
        })    
        }else{
            this.setState({ddlModuleData:JSON.parse(moduleStorageData)});
        }
    }


   

    addApprovalPathFunc = () => {


        if(this.state.gridData.length === 0) {
            this.growl.show({severity: 'error', summary: null, detail: 'Create atleast one approval flow'});
            return;
        }
        const stringData = this.state.gridData.reduce((result, item) => {
            return `${result}${item.type},`
        }, "")
        
       
        this.setState({loading : true});

        let approvalData = {          
            ApprovalPathName: this.state.approvalPathName,
            Flow: stringData,
            Isescalation: this.state.esGridData.length > 0 ? true : false, 
            IsActive: true,  
            CompanyId :  this.props.loggedUserDetail.CompanyId,
            Module:  parseInt(this.state.moduleId),
            ProcessId: this.state.processId,
            ProcessType : this.state.ProcessType
        };

        if(this.state.type === 'Add'){
            approvalData.Createdby = (this.props.loggedUserDetail.userName) ?? 'Admin';
            approvalData.Createddate = new Date();
        }

        if(this.state.type === 'Edit'){
            approvalData.Id  = this.state.Id;
            approvalData.ApprovalPathId    = this.state.approvalPathId;
            approvalData.Updatedby = (this.props.loggedUserDetail.userName) ?? 'Admin';
            approvalData.Updateddate = new Date();
        }

        let apporvalPathData = [];
        if(this.state.gridData && this.state.gridData.length > 0){
            apporvalPathData =  this.state.gridData.map(grid => {
                if(this.state.type === 'Add'){
                    return {
                        ApprovalPathSequence : grid.sequence,
                        ApprovalPathStageId : grid.stage,
                        ApprovalTypeId : grid.typeId,
                        Isactive : true,
                        AutoApprove : false,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                        Createdby : (this.props.loggedUserDetail.userName) ?? 'Admin',
                        Createddate : new Date()
                   }
                }else{
                    return {
                        //Id: grid.Id,
                        ApprovalPathDetailId : grid.ApprovalPathDetailId,
                        ApprovalPathId : grid.ApprovalPathId,
                        ApprovalPathSequence : grid.sequence,
                        ApprovalPathStageId : grid.stage,
                        ApprovalTypeId : grid.typeId,
                        Isactive : true,
                        AutoApprove : false,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                        Updatedby : (this.props.loggedUserDetail.userName) ?? 'Admin',
                        Updateddate : new Date()
                   }
                }
            })
        }
     

        let CharacteristicsData = [];
        if(this.state.characterData && this.state.characterData.length > 0){
            CharacteristicsData =  this.state.characterData.map(ch => {
                if(this.state.type === 'Add'){
                    return {
                        FieldName : ch.fieldName,
                        FieldValue : ch.fieldValue,
                        Isactive : true,
                        Operator: ch.operator,
                        ApprovalpathstageId: ch.stage,
                        ApprovaltypeId : ch.approvalType,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                        Createdby : (this.props.loggedUserDetail.userName) ?? 'Admin',
                        Createddate : new Date()
                }
                }else{
                    return {
                        CharId: ch.CharId,
                        ApprovalpathId: ch.ApprovalPathId,
                        FieldName : ch.fieldName,
                        FieldValue : ch.fieldValue,
                        Isactive : true,
                        Operator: ch.operator,
                        ApprovalpathstageId: ch.stage,
                        ApprovaltypeId : ch.approvalType,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                        Updatedby : (this.props.loggedUserDetail.userName) ?? 'Admin',
                        UpdateddAte : new Date()
                }
                }
            })
        }
      
        let EscalationData = [];
        if(this.state.esGridData && this.state.esGridData.length > 0){
            EscalationData =  this.state.esGridData.map(grid => {
                if(this.state.type === 'Add'){
                    return {
                        ApprovalPathStageId : grid.approvalPathStageId,
                        ApprovalPathProcess : this.state.processId,
                        EscalationLevel: grid.escalationLevel,
                        Days : grid.days,
                        HoursMinutes : grid.hoursMinutes,
                        EscalationTo : grid.escalationTo,
                        TotalMinutes : grid.totalMinutes,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                       
                   }
                }
                else{
                    return {
                        //Id: grid.Id,
                        ApprovalPathId : grid.ApprovalPathId,
                        ApprovalPathStageId : grid.approvalPathStageId,
                        ApprovalPathProcess : grid.processId,
                        EscalationLevel: grid.escalationLevel,
                        Days : grid.days,
                        HoursMinutes : grid.hoursMinutes,
                        EscalationTo : grid.escalationTo,
                        TotalMinutes : grid.totalMinutes,
                        CompanyId : this.props.loggedUserDetail.CompanyId,
                        
                   }
                }
            })
        }

        let finalData = {
            ApprovalPath : approvalData,
            ApprovalPathDetail : apporvalPathData,
            CharacteristicsMaster: CharacteristicsData,
            Escalation : EscalationData
        }
   
       
        let url = (this.state.type === 'Edit') ? '/master/api/UpdateDynamicData?model=ApprovalPath' : '/master/api/InsertDynamicData?model=ApprovalPath'
       
        let message = (this.state.type === 'Edit') ? 'Approval path updated successufully' : 'Approval path added successufully'

        var dd = JSON.stringify(finalData);
        var datas = {Key : dd};
     

        axios.post(url,JSON.stringify(datas))
            .then(response =>{  
                if(response.data.statusCode === 1){ 
                    //localStorage.removeItem('approvalPathData');
                    this.setState({approvalId:response.data.message});
                    this.growl.show({severity: 'success', summary: null, detail: message});  
                    this.setState({loading : false});  
                    this.clear();                  
                    this.getApprovalPath();
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                    this.setState({loading : false});
                }
                
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })   

    }


    
    approvalName = (id) => {
        let approvalTypeName = this.props.ApprovalType.filter(list => {
            return list.value === id;
        }).reduce((_,el) => {
            return el.label;
        },'')
        return approvalTypeName;
    }

    fieldName = (id) => {
        let fieldName = this.state.ddlFieldData.filter(list => {
            return list.value === id;
        }).reduce((_,el) => {
            return el.label;
        },'')
        return fieldName;
    }

    


    addCharacter = () => {
        let fieldName = this.fieldName(this.state.FieldName);
        let approvalTypeName = this.approvalName(this.state.ApprovaltypeId);
        let data = [...this.state.characterData,{
                    approvalType: this.state.ApprovaltypeId,
                    approvalTypeName: approvalTypeName,
                    stage : this.state.ApprovalpathstageId,
                    fieldName: this.state.FieldName,
                    operator: this.state.Operator,
                    fieldValue: this.state.FieldValue,
                    fieldNames : fieldName
                }
        ]

        this.setState({characterData:data,ApprovaltypeId:null,ApprovalpathstageId:null,Operator:null,FieldName:null,FieldValue:''})
    }

    addGrid = () => {
        let approvalTypeName = this.approvalName(this.state.approvalType);
        let gridData = '';
        if(this.state.rowData !==null){
             gridData = [...this.state.gridData];


            gridData[this.state.rowDataIndex] = {
             
                sequence: this.state.sequence,
                stage: this.state.stage,
                type: approvalTypeName,
                typeId: this.state.approvalType
            }
            if(this.state.rowData.Id!==undefined){
                gridData[this.state.rowDataIndex].ApprovalPathDetailId = this.state.rowData.ApprovalPathDetailId;
                gridData[this.state.rowDataIndex].ApprovalPathId = this.state.rowData.ApprovalPathId;
                gridData[this.state.rowDataIndex].Id =  this.state.rowData.Id;
            }
            
        }else{
            
             gridData = [...this.state.gridData,{
                                                    type: approvalTypeName,
                                                    typeId : this.state.approvalType,
                                                    stage: this.state.stage,
                                                    sequence: this.state.sequence
                                                }
            ]
        }

        

        this.setState({gridData:gridData,approvalType:null,typeId:null,stage:null,sequence:null,rowData:null,rowDataIndex:null})
    }

    editGrid = (rowData,index) => {
        this.setState({rowData : rowData, rowDataIndex : index,approvalType:rowData.typeId,stage:parseInt(rowData.stage),sequence:parseInt(rowData.sequence)})
    }

    cancelGrid = () => {
        this.setState({rowData:null,rowDataIndex : null,approvalType:null,stage:null,sequence:null,typeId:null}) 
    }

    escalationName = (id) =>{
        let escalationName = this.state.ddlEmployeeData.filter(list => {
                return list.value === id;
            }).reduce((_,el) => {
                return el.label;
            },'')
            return escalationName;
    }

    addEsGrid = () => {
    
    let escalationName = this.escalationName(this.state.esTo);
    
    let data = [...this.state.esGridData,{

                                            id: null,
                                            approvalPathId : this.state.approvalId,
                                            approvalPathStageId: this.state.esStage,
                                            approvalPathProcess: this.state.moduleName,
                                            escalationLevel: this.state.esLevel,
                                            days: this.state.esDays,
                                            hoursMinutes: this.state.esSubHour,
                                            escalationName: escalationName,
                                            escalationTo: this.state.esTo,
                                            totalMinutes : null
                                        }
    ]

    this.setState({esGridData:data,esTo:null,esStage:null,esLevel:null,esDays:'',esHour:null,esSubHour:null})
    }

    gridTemplate = (rowData, column) => {
        return <div className="actionCenter">
                {(this.state.type === 'Edit') && <Button  className="p-button-info" onClick={() => this.editGrid(rowData,column.rowIndex)} icon="pi pi-pencil"  />}
                <Button  className="p-button-danger" onClick={() => this.deleteGrid(rowData,column)} icon="pi pi-trash"  />
            </div>;
    }

    esGridTemplate = (rowData, column) => {
        return <div>
                    <Button  className="p-button-danger" onClick={() => this.deleteEsGrid(rowData,column)} icon="pi pi-trash"  />
            </div>;
    }

    esCharacterTemplate = (rowData, column) => {
        return <div>
                    <Button  className="p-button-danger" onClick={() => this.deleteCharacterGrid(rowData,column)} icon="pi pi-trash"  />
            </div>;
    }

    deleteGrid = (data, index) => {
        if(this.state.gridData.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.gridData.filter( (value , index) => {
                return index!== rowIndex;
            }); 
            this.setState({gridData:updatedValue});
        }
    }

    deleteEsGrid = (data, index) => {

        if(this.state.esGridData.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.esGridData.filter( (value , index) => {
                return index!== rowIndex;
            });    
    
            this.setState({esGridData:updatedValue});
        }

    }
    
    deleteCharacterGrid = (data, index) => {

        if(this.state.characterData.length > 0){
            let rowIndex = index.rowIndex;
            const updatedValue = this.state.characterData.filter( (value , index) => {
                return index!== rowIndex;
            });    
    
            this.setState({characterData:updatedValue});
        }

    }
  
    esclation = (rowData, column) => {
        var d = rowData.isescalation === 0 ? 'No' : 'Yes';
        return <span >{d}</span>
    }
    
  
    render() {   

      
        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }
        
        let isEnabled = (this.state.approvalType !== null )  && (this.state.stage !== null ) && (this.state.sequence !== null );
        let isEsEnabled = this.state.esStage !== null   && this.state.esLevel !== null  && this.state.esDays !== null && this.state.esHour !== null && this.state.esTo !== null ;
        let isFormEnabled = this.state.approvalPathName !=='' && this.state.moduleName !== null;
        let isCharacterEnabled = (this.state.ApprovaltypeId !==null) && (this.state.ApprovalpathstageId !== null) && (this.state.Operator !== null) && (this.state.FieldValue !== '');
                     
        let classN = (this.state.display) ? 'dialogflex' : '';
        let nameSele = 'Update';
        let nameTitle = 'Update';
        if(this.state.type=== 'Add'){
            nameTitle = 'Add';
            nameSele = 'Save';
        }else if(this.state.type=== 'View'){
            nameTitle = 'View';
        }

        const dialogFooter = (
            <div>
                { ((this.state.type === 'Add' && this.getAccess!==undefined && this.getAccess.addAccess!== false) || 
                    (this.state.type === 'Edit' && this.getAccess!==undefined && this.getAccess.editAccess!== false)) &&
                <Button disabled={!isFormEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addApprovalPathFunc} label={nameSele}/>
                }
                <Button icon="pi pi-times" onClick={this.clear} label="Cancel" className="p-button-secondary" />
            </div>
        )   

        let processOptions = [];
        if((this.props.GetTimeOff && this.props.GetTimeOff.timeofftypeList!==undefined) || (this.props.ExpenseType && this.props.ExpenseType!==undefined)){
            if(this.state.ProcessTypeLabel == 'Select TimeOffType'){
                processOptions = this.props.GetTimeOff.timeofftypeList.map(list => {
                    return { label: list.name, value:list.timeOffId};
                });
            } else if(this.state.ProcessTypeLabel == 'Select Expense Type'){
                processOptions = this.props.ExpenseType;
            }
        }
        return (
            <div className="p-grid approvalPath">
                { this.state.loading && <div className="page-loader"></div>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Approval Path</h1>
                        <TabView activeIndex={0} >
                            <TabPanel header="Approval Path">
                            <div className="p-grid">
                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                                <Button style={{float: 'right'}} label="Add" icon="pi pi-plus" className="ml1" onClick={()=>this.setState({display:true})} />
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                <Button onClick={this.deleteApprovalPath} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger ml1"/>
                                }      

                                <Button onClick={this.export} style={{float: 'right'}} label="Export" icon="pi pi-download"  className="p-button-secondary"/>
                                </div>                                
                            </div>
                      
                            					 	
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                                <DataTable selection={this.state.selectedData} 
                                    onSelectionChange={e => this.setState({selectedData: e.value})} value={this.state.approvalPathData} ref={(el) => { this.dt = el; }} {...DATATABLE_CONFIG}>
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="approvalPathName" filterPlaceholder="Search Approval Path" filter={true} sortable={true} header="Approval Path Name" />
                                    <Column field="processName" filter={true} filterPlaceholder="Search Path Process"  header="Approval Path Process" />
                                    <Column field="flow" filter={true} filterPlaceholder="Search Flow"  header="Flow" />
                                    <Column field="isescalation" filter={true} body={this.esclation} filterPlaceholder="Search Escalated" header="Escalated" />
                                    <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                </DataTable>
                            </div>


                            <Dialog className={classN} header={nameTitle+" Approval Path"} visible={this.state.display} modal={true} blockScroll  style={{width: '80vw'}} footer={dialogFooter} onHide={this.clear}  >

                            <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Approval Path Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="approvalPathName"  onChange={(e) => this.updateDetail(e)} required placeholder="Approval Path Name" value={this.state.approvalPathName}/>
                                   </div>   
                            </div>
                            
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Module<span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Module" name="moduleId" value={this.state.moduleId} options={this.state.ddlModuleData} onChange={(e) => this.updateDetail(e)}   {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>

                          
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Process<span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Process Name" name="processId" value={this.state.processId} options={this.state.ddlProcessData} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div>
                            </div>

                            { this.state.ProcessTypeShow && 

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">{this.state.ProcessTypeLabel} </label>
                                <div className="mt1">
                                    <Dropdown style={{ width: '100%' }} placeholder={this.state.ProcessTypeLabel} options={processOptions} name="ProcessType" value={this.state.ProcessType} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>
                            }
                           
                            <div className="p-col-12 p-lg-12">
                                 <hr/>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Approval Type</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Approval Type" name="approvalType" value={this.state.approvalType} options={this.props.ApprovalType} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Stage</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Stage" name="stage" value={this.state.stage} options={this.state.stages} onChange={(e) => this.updateDetail(e)}  {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Sequence</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Sequence" name="sequence" value={this.state.sequence} options={this.state.stages} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>



                            <div className="p-col-12 p-md-6 p-lg-3"><label className="label" style={{visibility:"hidden"}}>.</label>
                                <div className="mt1">
                                <Button disabled={!isEnabled} className="p-button-primary"  icon={(this.state.rowData!==null) ? 'pi pi-check' : 'pi pi-plus'} onClick={this.addGrid} label={(this.state.rowData!==null) ? 'Update' : 'Add'} />
                                
                                { (this.state.rowData!==null) &&
                                <Button className="p-button-secondary ml1"  icon="pi pi-times" onClick={this.cancelGrid} label={'Cancel'} />
                                }
                                
                                </div> 
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.gridData}>                            
                                    <Column field="type"  header="Approval Type" />
                                    <Column field="stage"  header="Stage" sortable={true}/>
                                    <Column field="sequence"  header="Sequence" sortable={true}/>                                
                                    <Column body={this.gridTemplate} style={{ textAlign: 'center', width: '8em' }}  header="Action"/>
                                </DataTable>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                 <hr/>
                                 <h1>Add Characteristics</h1>
                            </div>
                            
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Approval Type</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Approval Type" name="ApprovaltypeId" value={this.state.ApprovaltypeId} options={this.props.ApprovalType} onChange={(e) => this.updateDetail(e)} {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>
                           
                            
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Stage</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Stage" name="ApprovalpathstageId" value={this.state.ApprovalpathstageId} options={this.state.stages} onChange={(e) => this.updateDetail(e)}  {...DROPDOWN_CONFIG} style={{ width: '100%' }}/>
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Field Name</label>
                                <div className="mt1">
                                <Dropdown placeholder="Select Field Name" name="FieldName" value={this.state.FieldName} options={this.state.ddlFieldData}  onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />
                                </div>   
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Operator</label>
                                <div className="mt1">


                                <Dropdown placeholder="Select Operator" options={RELATIONAL_OPERATORS} name="Operator" value={this.state.Operator}  onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />

                                </div>   
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Field Value</label>
                                <div className="mt1">
                                <InputText value={this.state.FieldValue} placeholder="Field Value" name="FieldValue" onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} />
                                </div>   
                            </div>
                            
                            <div className="p-col-12 p-md-6 p-lg-3"><label className="label" style={{visibility:"hidden"}}>.</label>
                                <div className="mt1">
                                <Button disabled={!isCharacterEnabled} className="p-button-primary"  icon="pi pi-plus" onClick={this.addCharacter} label="Add" />
                                </div> 
                            </div>


                            <div className="p-col-12 p-lg-12">
                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.characterData}>                            
                                         
                                    <Column field="approvalTypeName" header="Approval Type" />
                                    <Column field="stage"  header="Stage" /> 
                                    <Column field="fieldNames"   header="Field Name" />
                                    <Column field="operator" header="Operator" />                                
                                    <Column field="fieldValue"  header="Field Value" />                           
                                    <Column body={this.esCharacterTemplate} style={{ textAlign: 'center', width: '8em' }}  header="Action"/>
                                </DataTable>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                 <hr/>
                            </div>
                
                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Stage</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Stage" appendTo={document.body}  position="top" name="esStage" value={this.state.esStage} options={this.state.stages} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} filter={true} filterPlaceholder="Select Stage" showClear={true} />
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Level</label>
                                <div className="mt1">
                                    <Dropdown placeholder="Select Level" appendTo={document.body}  name="esLevel" value={this.state.esLevel} options={this.state.stages} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} filter={true} filterPlaceholder="Select Level" showClear={true} />
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Days</label>
                                <div className="mt1">
                                    <InputText  value={this.state.esDays} placeholder="Days" name="esDays" onChange={(e) => this.updateDetail(e)} />
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Hours/Minutes</label>
                                <div className="mt1">
                                    <Calendar value={this.state.esHour} name="esHour" onChange={(e) => this.updateDetail(e)} timeOnly={true} hourFormat="12" />
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">Esclation To</label>
                                <div className="mt1">
                                <Dropdown placeholder="Select Esclation To" dataKey="employeeId" name="esTo" value={this.state.esTo} options={this.props.ApprovalType} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} {...DROPDOWN_CONFIG}  />
                                </div> 
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3"><label className="label" style={{visibility:"hidden"}}>.</label>
                                <div className="mt1">
                                <Button disabled={!isEsEnabled} className="p-button-primary"  icon="pi pi-plus" onClick={this.addEsGrid} label="Add" />
                                </div> 
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}  rows={10} value={this.state.esGridData}>                            
                                    <Column field="approvalPathStageId" header="Stage" />
                                    <Column field="escalationLevel" header="Level" /> 
                                    <Column field="days"  header="Days" />
                                    <Column field="hoursMinutes"  header="Hours/Minutes" />                                
                                    <Column field="escalationName"  header="Esclation To" body={(rowData) => this.approvalName(rowData.escalationTo)} />                               
                                    <Column body={this.esGridTemplate} style={{ textAlign: 'center', width: '8em' }}  header="Action"/>
                                </DataTable>
                            </div>
                      
                        </div>
                        </Dialog>


                        </div>

                            </TabPanel>
                            
                            <TabPanel header="Assigning">
                                <Assigning approvalOption={this.state.approvalPathData} loggedUserDetail={this.props.loggedUserDetail} ddlModuleData={this.state.ddlModuleData}/>
                            </TabPanel>
                        </TabView>
               
                        
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        ApprovalType: (state.keyword.ApprovalType!==undefined) ? state.keyword.ApprovalType : [],
        GetTimeOff : (state.keyword.GetTimeOff!==undefined) ? state.keyword.GetTimeOff : [],
        ExpenseType: state.keyword.ExpenseType || []
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterCommonList : (value) => dispatch(actions.getMasterCommonList(value)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(ApprovalPath);